import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";
import { WmsTransportDetailDto } from "src/dtos/wmsTransport/wmsTransportDto";

export type KSK1110_R01ValueType = "NUMERIC" | "TEXT" | "PASS_FAIL";
export const KSK1110_R01_VALUE_FIELDS = [
	"inspectValue1_1",
	"inspectValue1_2",
	"inspectValue1_3",
	"inspectValue1_4",
	"inspectValue1_5",
] as const;
export type KSK1110_R01InspectionValueField = typeof KSK1110_R01_VALUE_FIELDS[number];

export interface KSK1110_R01Dto {
	header: KSK1110_R01HeaderDto;
	detailList: KSK1110_R01DetailDto[];
}

export interface KSK1110_R01HeaderDto extends WmsTransportDetailDto {
	compNm: string;
	inoutClass: string;
	inoutClassNm: string;
	customCd: string;
	customNm: string;
	itemNm: string;
	itemSpec: string;
	itemGroup: string;
	lotNo: string;
	inspectNo: string;
}

export interface KSK1110_R01DetailDto extends TqcInspectResultDtlDto {
	compCd: string;
	compNm: string;
	inspectType: string;
	inspectTypeNm: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	supplierCustom: string;
	supplierCustomNm: string;
	workplaceCd: string;
	workplaceNm: string;
	jobTeam: string;
	itemNm: string;
	workerEmp: string;
	workerEmpNm: string;
	inspectQty: number;
	badQty: number;
	acceptQty: number;
	badCase: string;
	badCaseNm: string;
	judgeEmpno: string;
	judgeEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	headerRemark: string;
	inspItemGroup: string;
	inspType: string;
	inspItemNm: string;
	specValue1: string;
	specRange: string;
	specRangeNm: string;
	specValue2: string;
	specRemark?: string;
	inspUnit: string;
	valueType: KSK1110_R01ValueType | "";
	valueTypeNm: string;
	inspMethod: string;
	inspMethodNm: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultKSK1110_R01HeaderDto: KSK1110_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	transportNo: "",
	itemNo: "",
	compCd: "",
	logicCenter: "",
	transportDt: undefined,
	inoutType: "",
	itemCd: "",
	itemStatus: "",
	unit: "",
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: "",
	basOrderNo: "",
	basOrderItemNo: "",
	inspectionResult: "",
	remark: "",
	inserted: false,
	isModified: false,
	compNm: "",
	inoutClass: "",
	inoutClassNm: "",
	customCd: "",
	customNm: "",
	itemNm: "",
	itemSpec: "",
	itemGroup: "",
	lotNo: "",
	inspectNo: "",
};

export const defaultKSK1110_R01DetailDto: KSK1110_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	compCd: "",
	compNm: "",
	inspectType: "IQC",
	inspectTypeNm: "",
	inspectorEmp: "",
	inspectorEmpNm: "",
	supplierCustom: "",
	supplierCustomNm: "",
	workplaceCd: "",
	workplaceNm: "",
	jobTeam: "",
	itemNm: "",
	workerEmp: "",
	workerEmpNm: "",
	inspectQty: 0,
	badQty: 0,
	acceptQty: 0,
	badCase: "",
	badCaseNm: "",
	judgeEmpno: "",
	judgeEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	headerRemark: "",
	inspItemGroup: "",
	inspType: "",
	inspItemNm: "",
	specValue1: "",
	specRange: "",
	specRangeNm: "",
	specValue2: "",
	specRemark: "",
	inspUnit: "",
	valueType: "",
	valueTypeNm: "",
	inspMethod: "",
	inspMethodNm: "",
	inserted: false,
	isModified: false,
};

export const defaultKSK1110_R01Dto: KSK1110_R01Dto = {
	header: defaultKSK1110_R01HeaderDto,
	detailList: [],
};
